export const defaultColumns = [
    { label: 'Status', value: 'status', className: 'w-20' },
    { label: 'Código', value: 'reference_number', className: 'w-20' },
    { label: 'Estabelecimento', value: 'establishment_company_branch_display_name'},
    { label: 'Último consumo', value: 'last_consumption'},
    { label: 'Modelo', value: 'model_display', className: 'w-9' },
    { label: 'Visto por último', value: 'last_seen_at', className: 'w-9' },
    { label: 'Ações', value: 'actions', className: 'w-9' },
  ]
